export const areFiltersDefault = (filters) => {
    const defaultFilters = {
        searchText: null,
        statut: "pending",
        responsable_id: null,
        modele_id: null,
        etape_id: null,
        priorite_id: null,
        departement_id: null,
        affaire_id: null,
        statut_id: null,
        resolu: false,
        showMines: false, // Default for non "pour moi" pages
    };

    for (const key in filters) {
        if (key === 'showMines' && filters[key] === true) {
            // This is a "pour moi" page, so this is not a default filter
            continue;
        }
        if (filters[key] !== defaultFilters[key]) {
            return false;
        }
    }
    return true;
};
